import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const InputGroup = styled.div`
  display: flex;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  button {
    font-size: ${rem(14)};
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    padding: ${rem(0)} ${rem(13)};
    margin-top: ${rem(24)};
    width: 100%;
  }
`;


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: '0';
  height: '22px';
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  margin-bottom: ${rem(10)};
`;

export const StyledLabel = styled.label`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  font-weight: 600;
  margin-right: ${rem(8)};
`;

export const DropdownWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  display: 'block';
  position: absolute;
  bottom: ${rem(4)};
  right: ${rem(8)};
  pointer-events: none;

  & svg {
    pointer-events: none;
  }
`;